import { TaxSetupQuestion } from "v2/constants/taxSetupQuestions";
import {
  TAX_SETUP_SECTION_ORDER,
  TAX_SETUP_SECTION_TITLES,
  TaxSetupSectionId,
} from "v2/constants/taxSetupSections";

export type QuestionSection = {
  id: TaxSetupSectionId;
  title: string;
  questions: TaxSetupQuestion[];
};

export const groupQuestionsBySection = (
  questions: TaxSetupQuestion[]
): QuestionSection[] =>
  TAX_SETUP_SECTION_ORDER.map((id) => ({
    id,
    title: TAX_SETUP_SECTION_TITLES[id],
    questions: questions.filter((question) => question.section === id),
  })).filter((section) => section.questions.length > 0);
